import { PaypalButton } from '../PaypalButton/PaypalButton';
import { connectPayPalButton } from './connectPaypalButton';

export const ConnectedPaypalButton = connectPayPalButton(PaypalButton);
